import { render, staticRenderFns } from "./ProductAttributesDialog.vue?vue&type=template&id=534cc77e&scoped=true"
import script from "@/views/Variants/ProductAttributesDialog.ts?vue&type=script&lang=ts&external"
export * from "@/views/Variants/ProductAttributesDialog.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Variants/product-attributes-dialog.scss?vue&type=style&index=0&id=534cc77e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534cc77e",
  null
  
)

export default component.exports